module.exports = __webpack_public_path__ + "img/040-bhutan.a14c6695.svg";